import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import { SsoAutoLogin } from './SsoAutoLogin';
import { withProviders } from '../../../core/components';
export default angular
    .module('doxy.sso.sso-auto-login', [])
    .component('ssoAutoLogin', {
    bindings: {},
    template: `<div></div>`,
    controller: function ($element) {
        const reactContainer = $element[0];
        const render = () => {
            ReactDOM.render(React.createElement(withProviders(SsoAutoLogin), {}), reactContainer);
        };
        this.$onInit = render;
    },
}).name;
